import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
